module.exports = __webpack_public_path__ + "static/img/user.68093b70.svg";